import "./ampBannerCss.scss"
import { Grid, Typography, Box, Card, CardContent } from "@mui/material";
import AudioCompare from "../../Utilities/AudioCompare";

import skinScraper from "../../../static/images/distant_bass_suite/amplifier-skin-scraper.webp"
import fleshweaver from "../../../static/images/distant_bass_suite/amplifier-fleshweaver.webp"
import skinScraperFullMix from "../../../static/audio/distant_bass_suite/skinscraper-full-mix.mp3"
import skinScraperBassOnly from "../../../static/audio/distant_bass_suite/skinscraper-bass-only.mp3"
import fleshweaverFullMix from "../../../static/audio/distant_bass_suite/fleshweaver-full-mix.mp3"
import fleshweaverBassOnly from "../../../static/audio/distant_bass_suite/fleshweaver-bass-only.mp3"
import {
  FLESHWEAVER_BASS_ONLY_WAVEFORM,
  FLESHWEAVER_FULL_MIX_WAVEFORM,
  SKINSCRAPER_BASS_ONLY_WAVEFORM,
  SKINSCRAPER_FULL_MIX_WAVEFORM,
} from "./audioWaveforms";

const SKINSCRAPER_AUDIO = {
  audios: [
    { src: skinScraperFullMix, label: "Full mix", waveform: SKINSCRAPER_FULL_MIX_WAVEFORM },
    { src: skinScraperBassOnly, label: "Bass only", waveform: SKINSCRAPER_BASS_ONLY_WAVEFORM },
  ],
};

const FLESHWEAVER_AUDIO = {
  audios: [
    { src: fleshweaverFullMix, label: "Full mix", waveform: FLESHWEAVER_FULL_MIX_WAVEFORM },
    { src: fleshweaverBassOnly, label: "Bass only", waveform: FLESHWEAVER_BASS_ONLY_WAVEFORM },
  ],
};

const TEXT_COLOR = "#000";
const ALT_TEXT_COLOR = "#000";

const Paragraph = ({ title, children, smallTitle }) => {
  return <Box sx={{ mt: 2, textAlign: "left" }}>

    <Typography sx={{ fontSize: { md: "23px", xs: "16px" } }} variant="body2" ><b>{title}:</b> {children}</Typography>
  </Box>
}

const AmplifierBanner = () => {
  return (
    <>
      <Box sx={{ p: 5, background: "radial-gradient(circle, #eee 0%,#aaa 100%)", justifyContent: "center", alignItems: "center", color: TEXT_COLOR }} >
        <Box sx={{ width: "100%", justifyContent: "center" }}>
          <Typography variant="h3" sx={{ textAlign: "center", mb: 3 }}>The Amplifier Collection</Typography>

        </Box>
        <Grid container justifyContent={"center"}>
          <Grid item xs={12} md={6} lg={4} sx={{ color: TEXT_COLOR }}>
            <Typography variant="h6" sx={{ textAlign: "center" }}>
              <b>BassSuite - Distant</b> contains two handcrafted amplifiers designed to cover a broad range of sounds. From modern, sculpted bass tones to old-school hardcore bass with an edge.
            </Typography>
          </Grid>
        </Grid>
        <Grid container justifyContent={"center"} sx={{}}>
          <Grid item xs={12} md={10} sx={{ mt: 3 }}>
            <Box
              component="img"
              src={skinScraper}
              alt="Skinscraper bass processor"
              sx={{ display: "block", width: { xs: "100%", md: "75%" }, height: "auto", mx: "auto" }}
            />
          </Grid>

        </Grid>
        <Grid container justifyContent={"center"} sx={{}}>
          <Grid item xs={12} md={6} lg={6} sx={{ color: TEXT_COLOR }}>
            <Typography sx={{ textAlign: "center", mb: 3, color: TEXT_COLOR }} color={TEXT_COLOR} variant="h3">SKINSCRAPER</Typography>
            <Typography sx={{ textAlign: "center", mb: 3 }} variant="h6">Built to sit perfectly in the densest, heaviest, guitar-focused mixes, Skinscraper delivers the ideal modern bass tone.</Typography>
            <Typography sx={{ textAlign: "center", mb: 3 }} variant="h6">Control three individual bands with dedicated level controls, plus compression and drive for added character. The five-band graphic EQ provides the final layer of precise tonal fine-tuning.</Typography>
            <Box sx={{ mt: 4, p: { xs: 2, md: 2.5 }, color: "#F9F5EE", background: "radial-gradient(circle at top, #3a3a3a 0%, #1a1a1a 72%)", border: "1px solid rgba(249, 245, 238, 0.16)", borderRadius: 2, boxShadow: "0 14px 32px rgba(0, 0, 0, 0.22)" }}>
              <Typography variant="overline" sx={{ color: "#F9F5EE", fontWeight: 800, letterSpacing: "0.16em" }}>Tone comparison</Typography>
              <Typography variant="h6" sx={{ mt: -0.25, fontWeight: 700 }}>Hear Skinscraper in the mix</Typography>
              <AudioCompare section={SKINSCRAPER_AUDIO} dense crossfadeMs={650} appearance="showcase" />
            </Box>
          </Grid>
        </Grid>

      </Box >

      <Box sx={{ p: 5, background: "radial-gradient(circle, #3a3a3a 0%,#1a1a1a 100%)", justifyContent: "center", alignItems: "center", }} >
        <Grid container justifyContent={"center"} sx={{}}>
          <Grid item xs={12} md={10}>
            <Box
              component="img"
              src={fleshweaver}
              alt="Fleshweaver amplifier"
              sx={{ display: "block", width: { xs: "100%", md: "75%" }, height: "auto", mx: "auto" }}
            />
          </Grid>

        </Grid>
        <Grid container justifyContent={"center"} sx={{}}>
          <Grid item xs={12} md={6} lg={6} sx={{}}>
            <Typography sx={{ textAlign: "center", mb: 3, }} variant="h3">FLESHWEAVER</Typography>
            <Typography sx={{ textAlign: "center", mb: 3 }} variant="h6">A familiar name with a familiar approach: <i>Too Much is Not Enough</i>. </Typography>
            <Typography sx={{ textAlign: "center", mb: 3 }} variant="h6">Fleshweaver brings a classic, heavily distorted bass tone to the mix.<br></br>Its midrange-forward character helps it cut through when needed, while controlled compression keeps it from overwhelming the rest of the mix. Push the Overkill control to take it all the way into fuzz territory.</Typography>
            <Box sx={{ mt: 4, p: { xs: 2, md: 2.5 }, color: "#F9F5EE", background: "radial-gradient(circle at top, #3a3a3a 0%, #1a1a1a 72%)", border: "1px solid rgba(249, 245, 238, 0.16)", borderRadius: 2, boxShadow: "0 14px 32px rgba(0, 0, 0, 0.22)" }}>
              <Typography variant="overline" sx={{ color: "#F9F5EE", fontWeight: 800, letterSpacing: "0.16em" }}>Tone comparison</Typography>
              <Typography variant="h6" sx={{ mt: -0.25, fontWeight: 700 }}>Hear Fleshweaver in the mix</Typography>
              <AudioCompare section={FLESHWEAVER_AUDIO} dense crossfadeMs={650} appearance="showcase" />
            </Box>
          </Grid>
        </Grid>

      </Box >
    </>
  )
}

export default AmplifierBanner;
